export const departments = [
  {
    value: "Freight Services",
    label: "Freight Services",
    services: [
      {
        value: "Request a Quote",
        label: "Request a Quote",
        email: "EUcustomer@rpmmoves.com",
      },
      { value: "LTL", label: "LTL", email: "EUcustomer@rpmmoves.com" },
      {
        value: "Chemical & Hazmat",
        label: "Chemical & Hazmat",
        email: "EUcustomer@rpmmoves.com",
      },
      {
        value: "Expedited",
        label: "Expedited",
        email: "EUcustomer@rpmmoves.com",
      },
      {
        value: "High & Heavy",
        label: "High & Heavy",
        email: "EUcustomer@rpmmoves.com",
      },
      {
        value: "Oversized",
        label: "Oversized",
        email: "EUcustomer@rpmmoves.com",
      },
      { value: "FTL", label: "FTL", email: "EUcustomer@rpmmoves.com" },
      { value: "Goods", label: "Goods", email: "EUcustomer@rpmmoves.com" },
    ],
  },
  {
    value: "Vehicle Services",
    label: "Vehicle Services",
    services: [
      {
        value: "Request a Quote",
        label: "Request a Quote",
        email: "EUcustomer@rpmmoves.com",
      },
      { value: "OEM", label: "OEM", email: "EUcustomer@rpmmoves.com" },
      {
        value: "Remarketing",
        label: "Remarketing",
        email: "EUcustomer@rpmmoves.com",
      },
      { value: "Retail", label: "Retail", email: "EUcustomer@rpmmoves.com" },
      { value: "Auction", label: "Auction", email: "EUcustomer@rpmmoves.com" },
      {
        value: "Dealership",
        label: "Dealership",
        email: "EUcustomer@rpmmoves.com",
      },
      {
        value: "POV / Carvaygo",
        label: "POV / Carvaygo",
        email: "support@carvaygo.com;UScustomer@rpmmoves.com",
      },
      { value: "Rental", label: "Rental", email: "EUcustomer@rpmmoves.com" },
      {
        value: "Fleet Management",
        label: "Fleet Management",
        email: "EUcustomer@rpmmoves.com",
      },
    ],
  },
  {
    value: "Freight Carrier",
    label: "Freight Carrier",
    services: [
      {
        value: "Request a Quote",
        label: "Request a Quote",
        email: "EUcarrier@rpmmoves.com",
      },
      {
        value: "Operations Support",
        label: "Operations Support",
        email: "EUcarrier@rpmmoves.com",
      },
      {
        value: "New Carrier Inquiry",
        label: "New Carrier Inquiry",
        email: "EUcarrier@rpmmoves.com",
      },
    ],
  },
  {
    value: "Vehicle Carrier",
    label: "Vehicle Carrier",
    services: [
      {
        value: "Request a Quote",
        label: "Request a Quote",
        email: "EUcarrier@rpmmoves.com",
      },
      {
        value: "Operations Support",
        label: "Operations Support",
        email: "EUcarrier@rpmmoves.com",
      },
      {
        value: "New Carrier Inquiry",
        label: "New Carrier Inquiry",
        email: "EUcarrier@rpmmoves.com",
      },
    ],
  },
  {
    value: "Accounting - Finance",
    label: "Accounting / Finance",
    services: [
      {
        value: "Customer Billing Inquiry",
        label: "Customer Billing Inquiry",
        email: "AR@LoadRPM.com",
      },
      {
        value: "Claims Support",
        label: "Claims Support",
        email: "acct.claimshelpdesk@rpmmoves.com",
      },
      {
        value: "Quick Pay Support",
        label: "Quick Pay Support",
        email: "status@loadrpm.com",
      },
    ],
  },
  {
    value: "Information Technology",
    label: "Information Technology",
    services: [
      {
        value: "RPM Hub App Support",
        label: "RPM Hub App Support",
        email: "EUtech@rpmmoves.com",
      },
      {
        value: "RPM Marketplace Support",
        label: "RPM Marketplace Support",
        email: "EUtech@rpmmoves.com",
      },
      {
        value: "Turvo Support",
        label: "Turvo Support",
        email: "EUtech@rpmmoves.com",
      },
    ],
  },
  {
    value: "Marketing",
    label: "Marketing",
    services: [
      {
        value: "Media Coverage",
        label: "Media Coverage",
        email: "marketing@rpmmoves.com",
      },
      {
        value: "Public Relations",
        label: "Public Relations",
        email: "marketing@rpmmoves.com",
      },
      {
        value: "Sponsorships / Partnership Opportunity",
        label: "Sponsorships / Partnership Opportunity",
        email: "marketing@rpmmoves.com",
      },
    ],
  },
];
